import {Injectable, Injector} from '@angular/core';
import {EntityCollectionServiceElementsFactory} from '@ngrx/data';
import {AbstractRepositoryV2} from '../../../../../../core/service/v2/abstractRepositoryV2';
import {MedicalRecordPainModel} from '../../../api/model/medicalRecordPain.model';

@Injectable({providedIn: 'root'})
export class MedicalPainRepository extends AbstractRepositoryV2<MedicalRecordPainModel> {
    constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory, injector: Injector) {
        super('MedicalPain', serviceElementsFactory, injector);
    }
}
